import { Link } from "react-router-dom";

const footerLinks = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/legal-terms", label: "Legal" },
  { to: "/standard-building-policy", label: "Standard Building Policy" },
  { to: "/property-management", label: "Property Management" },
];

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="w-full px-8 md:px-16 lg:px-24 py-12">
        {/* Top row — logo left, nav right */}
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-8 mb-8">
          {/* Logo + contact */}
          <div className="flex flex-col gap-4">
            {/* <img
              src="/static/images/logo-white.png"
              alt="Artistic Spaces"
              className="h-10 w-auto"
              onError={(e) => {
                e.target.src = "https://www.artistic-spaces.co.uk/assets/logo.png";
              }}
            /> */}
            <div className="flex flex-col gap-1">
              <a href="tel:02033024266" className="text-sm text-gray-300 hover:text-white transition-colors">
                +44 (0)203 302 4266
              </a>
              <a href="mailto:hello@artistic-spaces.co.uk" className="text-sm text-gray-300 hover:text-white transition-colors">
                hello@artistic-spaces.co.uk
              </a>
            </div>
          </div>

          {/* Footer nav */}
          <nav className="flex flex-wrap gap-x-8 gap-y-2 md:justify-end">
            {footerLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 pt-6">
          <p className="text-sm text-gray-500">©{new Date().getFullYear()} Artistic Spaces</p>
        </div>
      </div>
    </footer>
  );
}